// Sound FX disabled by user request — kept as no-op stubs so imports still work.
const noop = () => {};

export const sfx = {
  click: noop,
  select: noop,
  deselect: noop,
  error: noop,
  success: noop,
  warp: noop,
  toast: noop,
  konami: noop,
};

export function isMuted() { return true; }
export function toggleMute() { return true; }
